<template>
	<div v-if="isVisible" class="popup-container">
		<div class="card white popup">
			<h2>{{ title }}</h2>
			<div class="form-group">
				<div class="form-control">
					<label for="name">Nom du travaux*</label>
					<input type="text" id="name" v-model="name" placeholder="Entrez un nom" required v-alpha-numeric />
				</div>
				<div class="form-control">
					<label for="entreprise">Entreprise</label>
					<input type="text" id="entreprise" v-model="entreprise" placeholder="Entrez une entreprise"
						v-alpha-numeric />
				</div>
			</div>

			<div class="form-control">
				<label for="description">Description</label>
				<textarea id="description" v-model="description" placeholder="Entrez une description"></textarea>
			</div>

			<div class="form-group">
				<div class="form-control">
					<label for="start_date">Date de début</label>
					<input type="date" id="start_date" name="start_date" v-model="start_date"
						@change="handleStartDateChange" />
				</div>

				<div class="form-control">
					<label for="end_date">Date de fin</label>
					<input type="date" id="end_date" name="end_date" v-model="end_date" @change="handleEndDateChange" />
				</div>
			</div>

			<div class="form-control">
				<label for="files" class="button outline orange dotted">Ajouter des fichiers</label>
				<input type="file" id="files" name="files" multiple @change="handleFileUpload" />
			</div>

			<div class="uploaded-files">
				<div v-for="file in uploadedFiles" :key="file.ID" class="file-entry">
					<i v-if="file.name.toLowerCase().endsWith('.pdf')" class="bi bi-file-pdf-fill"></i>
					<i v-else class="bi bi-file-image-fill"></i>
					<p class="file-name" @click="openPreview(file)">{{ file.name }}</p>
					<p class="file-action" @click="openPreview(file)">Voir</p>
					<p>|</p>
					<p class="file-action" @click="deleteFile(file)">Supprimer</p>
				</div>
			</div>

			<p v-if="errorMessage">{{ errorMessage }}</p>
			<div class="popup-actions">
				<button class="button fill orange" @click="confirmAction" :disabled="isUploading">
					{{ confirmButtonText }}
				</button>
				<button class="button outline orange" @click="cancelAction" :disabled="isUploading">
					{{ cancelButtonText }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		isVisible: Boolean,
		title: String,
		propID: {},
		confirmButtonText: {
			type: String,
			default: "Confirmer",
		},
		cancelButtonText: {
			type: String,
			default: "Annuler",
		},
	},
	data() {
		return {
			name: "",
			description: "",
			entreprise: "",
			start_date: "",
			end_date: "",
			uploadedFiles: [],
			errorMessage: "",
			isUploading: false,
		};
	},
	methods: {
		checkUploadFile(type) {
			return ["image/jpeg", "image/png", "application/pdf"].includes(type);
		},
		handleFileUpload(event) {
			const files = Array.from(event.target.files);
			for (const file of files) {
				if (this.checkUploadFile(file.type)) {
					const uploadFile = {
						name: file.name,
						size: file.size,
						type: file.type,
						blob: file,
					};
					this.uploadedFiles.push(uploadFile);
					this.errorMessage = "";
				} else {
					this.errorMessage = "Seuls les fichiers JPEG, PNG et PDF sont autorisés.";
				}
			}
		},
		async confirmAction() {
			if (!this.name) return this.errorMessage = "Veuillez remplir tous les champs requis.";

			try {
				this.isUploading = true;
				this.errorMessage = "";

				const formData = new FormData();
				formData.append("propID", this.propID);
				formData.append("name", this.name);
				formData.append("entreprise", this.entreprise);
				formData.append("start_date", this.start_date);
				formData.append("end_date", this.end_date);
				formData.append("description", this.description);
				this.uploadedFiles.forEach((file) => formData.append(`files`, file.blob));

				const response = await fetch(process.env.VUE_APP_API_URL + "travaux/add", { method: "POST", credentials: "include", body: formData, });
				const data = await response.json();

				if (data.message === "maxsize") return this.errorMessage = "La taille totale des fichiers dépasse la limite.";
				if (!response.ok) return this.errorMessage = "Une erreur est survenue lors de l'envoi.";
				this.$emit("confirm");
				this.resetForm();
			} catch (error) {
				console.error("Erreur lors de la soumission du formulaire:", error);
				this.errorMessage = "Erreur lors de l'envoi des données. Veuillez réessayer.";
			} finally {
				this.isUploading = false;
			}
		},
		resetForm() {
			this.name = "";
			this.description = "";
			this.uploadedFiles = [];
			this.start_date = "";
			this.end_date = "";
			this.errorMessage = "";
			this.isUploading = false;
		},
		cancelAction() {
			this.resetForm();
			this.$emit("cancel1");
		},
		openPreview(file) {
			if (!file) return;
			if (file.type.startsWith("image/")) {
				const reader = new FileReader();
				reader.onload = (e) => {
					const image = new Image();
					image.src = e.target.result;
					const previewWindow = window.open("", "_blank");
					previewWindow.document.write(image.outerHTML);
				};
				reader.readAsDataURL(file.blob);
			} else if (file.type === "application/pdf") {
				const pdfUrl = URL.createObjectURL(file.blob);
				const previewWindow = window.open(pdfUrl, "_blank");
				previewWindow.document.title = file.name;
			} else {
				this.errorMessage = "Seuls les fichiers JPEG, PNG et PDF sont autorisés.";
			}
		},
		deleteFile(file) {
			this.uploadedFiles = this.uploadedFiles.filter((f) => f !== file);
		},
	},
};
</script>

<style>
#files {
	width: 1px;
	height: 1px;
	padding: 0;
	opacity: 0;
}

#description {
	resize: vertical;
	line-height: 1.4;
	max-height: calc(1.4em * 10);
	overflow: auto;
}
</style>
